import { render, staticRenderFns } from "./SparkError404.vue?vue&type=template&id=f2c24a5a&"
import script from "./SparkError404.vue?vue&type=script&lang=js&"
export * from "./SparkError404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports